import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { filtersSelector } from 'store/modules/competition-nav/selectors/filters-selector';
import {
    useGetVenuesQuery,
    useGetMatchesQuery
} from 'store/modules/api/afl-api';
import { filterByCity } from '../../../../../sites/aflm/fixtures/js/utils/filter-by-city';

import { getTranslation } from '../../../utils/translations';
import { SelectMultiple } from '../../select-multiple';

import { UPDATE_FILTER_ITEM } from 'store/modules/competition-nav/actions';

export const VenueFilterItem = ({ addOnResetCallback, currentFilters }) => {
    const dispatch = useDispatch();

    const { competitionId, compSeason } = currentFilters;
    const filters = useSelector(filtersSelector);

    const { data: venuesList } = useGetVenuesQuery(compSeason.id, {
        skip: !compSeason.id ? true : false
    });

    const venues = useMemo(
        () =>
            venuesList
                ? [...venuesList].sort((a, b) => (a.name > b.name ? 1 : -1))
                : null,
        [venuesList]
    );

    const updateFilterItem = (filterItem, value) => {
        dispatch(UPDATE_FILTER_ITEM.request({ filterItem, value }));
    };

    const { data: matches = [] } = useGetMatchesQuery(
        {
            competitionId: competitionId,
            compSeasonId: compSeason.id,
            ...(filters.teams.length && { teamId: filters.teams }),
            ...(filters.venues.length && { venueId: filters.venues })
        },
        {
            skip: !competitionId || !compSeason.id
        }
    );

    const filteredMatches = filters.cities.length
        ? filterByCity(matches, filters.cities)
        : null;

    // if team or city selected
    // disable non-applicable venues

    let activeVenues = [];

    if (filters.teams.length || filters.cities.length) {
        if (filteredMatches?.length) {
            filteredMatches.forEach((match) => {
                activeVenues = [...activeVenues, match.venue?.id];
            });
        } else if (matches.length) {
            matches.forEach((match) => {
                activeVenues = [...activeVenues, match.venue?.id];
            });
        }
    }

    return (
        <SelectMultiple
            items={venues}
            getInitialSelectedItems={() => {
                return venues.filter((v) => filters.venues.includes(v.id));
            }}
            label={getTranslation('label.fixtures.filters.venue')}
            icon="venue"
            itemToString={(venue) => venue.name}
            onSelectedItemsChange={(venue) => {
                updateFilterItem(
                    'venues',
                    venue.map((v) => v.id)
                );
            }}
            addOnResetCallback={addOnResetCallback}
            getItemText={(item) => item.name}
            getItemLabel={(item) => (
                <span
                    style={{
                        alignItems: 'center',
                        display: 'flex',
                        justifyContent: 'space-between',
                        lineHeight: 1,
                        width: '100%'
                    }}
                >
                    <span style={{ marginRight: '1rem' }}>{item.name}</span>
                </span>
            )}
            getItemDisabled={(item) =>
                activeVenues.length && !activeVenues.includes(item.id)
            }
        />
    );
};

VenueFilterItem.propTypes = {
    addOnResetCallback: PropTypes.func,
    currentFilters: PropTypes.object
};
